import {AppBox, AppContainer, AppPaginator} from "../../../commons/components";
import {useEffect} from "react";
import PlayerList from "./components/PlayerList";
import {useAppDispatch, useAppSelector} from "../../../hooks/app";
import {
    cleanUpPlayerList,
    fetchManagePlayerList,
} from "../../../redux/slices/football/admin/player/manage-player-list-slice";
import {Outlet, useParams} from "react-router";
import {setPageTitle} from "../../../redux/slices/page-title-slice";
import {cleanUpManagePlayerAttribute} from "../../../redux/slices/football/admin/player/manage-player-attribute-slice";
import usePagination from "../../../hooks/usePagination";
import useFilter from "../../../hooks/useFilter";

export default function PlayerManage() {
    const {playerId} = useParams();
    const dispatch = useAppDispatch();
    const {playerList} = useAppSelector((state) => state.footballManagePlayerList);
    const {page, pageChange, pageLimitChange, perPage} = usePagination();
    const {sortBy, sortOrder, searchText,status} = useFilter();

    useEffect(() => {
        dispatch(setPageTitle("Players"));
    }, []);

    useEffect(() => {
        dispatch(fetchManagePlayerList({
            sort: sortBy,
            sortOrder,
            name: searchText,
            page,
            perPage,
            status
        }));
    }, [page, perPage, sortBy, sortOrder, searchText,status]);

    useEffect(() => {
        return () => {
            dispatch(cleanUpPlayerList());
            dispatch(cleanUpManagePlayerAttribute());
        };
    }, []);

    return (
        <>
            {playerId ? (
                <Outlet/>
            ) : (
                <AppContainer>
                    <AppBox py="md" flexDirection="column" gap="md">
                        <PlayerList>
                        </PlayerList>
                        {playerList.pageCount > 1 &&
                            <AppPaginator perPage={playerList?.perPage}
                                          pageCount={playerList?.pageCount}
                                          currentPage={playerList?.page}
                                          pageChange={pageChange}
                                          perPageLimitChange={pageLimitChange}
                            />
                        }
                    </AppBox>
                </AppContainer>
            )}
        </>
    );
}
